import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Switch, Route, Redirect } from 'react-router-dom'
import classnames from "classnames";
import Loader from '../../Loader'
import {Link} from 'react-router-dom';
import routes from './routes';

class PostTab extends React.Component {

state = {
  activeTab : "1",
  tabId:"",
  loading: false
}



  // static getDerivedStateFromProps(props, state) {
  //   const tabId = props.match.params.id;
  //   if (!tabId) {
  //     props.history.push("/blog/addblogpost");
  //   } else if (tabId !== state.tabId) {
  //     switch (tabId) {
  //       case "addblogpost":
  //         return { ...state, activeTab: "1", tabId };
  //       case "viewblog":
  //         return { ...state, activeTab: "2", tabId };
  //       case "aboutme":
  //         return { ...state, activeTab: "3", tabId };
  //       default:
  //         props.history.push("/blog/addblogpost");
  //     }
  //   }
  //   return null;
  // }



toggle = tab => {
  if (this.state.activeTab !== tab) {
    this.setState({
      activeTab: tab
    });
  }
};

componentDidMount() {
  // const tabId = this.props.match.params.id || "view";
  // console.log(tabId);
  // this.setState(prevState => ({
  //   activeTab: tabId
  // }))
  // this.props.history.push(`/blog/${tabId}`);
}

  render() {

    const { match, location } = this.props;

    if(this.state.loading == true) {
      return <Loader />
    }

    return (
      <div>
        <Nav tabs >
          <NavItem>
            <NavLink
              tag={Link}
              to={`${match.url}/view`}
              className={classnames({ active: location.pathname === "/blog/view" })}
              onClick={() => {
                this.toggle("view");
              }}
            >
              My Blog List
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              tag={Link}
              to={`${match.url}/create`}
              className={classnames({ active: location.pathname === "/blog/create" })}
              onClick={() => {
                this.toggle("add");
              }}
            >
              Write a Blog
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              tag={Link}
              to={`${match.url}/about`}
              className={classnames({ active: location.pathname === "/blog/about" })}
              onClick={() => {
                this.toggle("aboutme");
              }}
            >
              About Me
            </NavLink>
          </NavItem>
        </Nav>

        <Switch>
          {routes.map((route, index) => {
            return route.component ? (<Route key={index} path={`${match.path}/${route.path}`} render={props => (
              <route.component {...props} />
            )}/>)
            : null
          })}
          <Redirect from="/blog" to="/blog/view" />
        </Switch>

        {/* <TabContent activeTab={this.state.activeTab} >
          <TabPane tabId="view">
            <PostTableView />
          </TabPane>
          <TabPane tabId="add">
            <AddBlogPost />
          </TabPane>
          <TabPane tabId="aboutme">
            <AboutMe/>
          </TabPane>
        </TabContent> */}
      </div>
  );
}
}

export default PostTab;



// WEBPACK FOOTER //
// ./src/views/Blog/Post/PostTab.js